<template>
  <div class="container">
    <h1 class="text-center main-title" v-html="$t('title.product')">
      <!-- 产品<em>中心</em>
      <span>Products</span>-->
    </h1>

    <ul class="aside text-center">
      <li
        v-for="(item,index) in productdata"
        :key="index"
        class="aside-title"
        v-on:click="getId(item.id)"
      >
        <router-link :to="'/product/'+item.id" exact>{{item.name}}</router-link>
      </li>
    </ul>
    <!-- <swiper :options="swiperOption" ref="mySwiper" class="visible-xs">
      
      <swiper-slide
        v-for="(item,index) in productdata"
        :key="index"
        class="aside-title aside-swiper"
        
      >
        <router-link :to="'/product/'+item.id" key="index" exact>{{item.name}}</router-link>
      </swiper-slide>
      <div class="swiper-scrollbar" slot="scrollbar"></div>
    </swiper> -->

    <ul class="products-list clearfix">
      <li v-for="(item,index) in productTitle" :key="index" class="col-xs-6 col-sm-4 col-md-3" v-on:click='save(item.id)'>
        <router-link :to="'/product/dtails/'+item.id" key="index" >
          <img :src="item.img" alt>
          <p class="text-center products-name">{{item.title}}</p>
        </router-link>
      </li>
    </ul>
      <nav aria-label="Page navigation" v-show="page != 1 ? true:false">
          <ul class="pagination">
            <li :class="{ 'disabled': currentPage == 1} ">
              <a href="javascript:;" aria-label="Previous" v-on:click="sub">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li v-for="(item,i) in page" :key="i" >
              <a href="javascript:;" v-on:click="addcurrentPage(i)" :class="{ 'active': (i+1) == currentPage}">{{i+1}}</a>
            </li>
            <li :class="{ 'disabled': page == currentPage}">
              <a href="javascript:;" aria-label="Next" v-on:click="add" >
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
  </div>
</template>

<script>
let head = document.getElementsByTagName('head');        // 创建head标签
let meta1 = document.createElement('meta');           // 创建meta标签
let meta2 = document.createElement('meta');

meta1.name = "keywords";                         // 设置name
meta2.name = "description";
export default {
  name: "Product",
   metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
  data() {
    return {
      productTitle: {},
      total: "", // 数据总条数
      display: 8, // 每页显示条数
      currentPage: 1,// 当前页码
      notNextTick: true,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        
        loop: true,
        slidesPerView: 2,
        scrollbar: {
          el: ".swiper-scrollbar",
          snapOnRelease: true
        }
      }
    };
  },
 watch: {
    $route() {
      //console.log(this.$route.params);
      //this.getDate();
      var id=this.$route.params.productId;
      this.getId(id);
      
    }
  },
  computed: {
     pageName(){
      return this.$t("mteaTitle.product");
    },
    productdata() {
      return this.$t("nav_foot[1].subnavigation");
    },
     page: function() {
      // 总页数
      return Math.ceil(this.total / this.display);
    }
    //  pageName(){
    //   return this.$t("nav[2].name");
    // }
  
  },
  mounted() {
  
    this.$http
      .get("http://www.hzjingbao.cn/api/category", {
        params: {
          lang: this.$i18n.locale,
        }
      })
      .then(res => {
        //console.log(res.data);
        if (this.productdata.length < 4) {
          this.productdata.push(...res.data);
        }

       // console.log(this.productdata.length);
      })
      .catch(erroe => {
        console.log(error);
      })
     
  },

  methods: {
    getId(id) {
      console.log(id)
      sessionStorage.setItem("product", id);
      this.$http
        .get("http://www.hzjingbao.cn/api/product", {
          params: {
            lang: this.$i18n.locale,
            category: id,
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          //this.aboutInfo = res.data;
          this.total= res.data.total;
          this.productTitle = res.data.rows;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    addcurrentPage(i) {
      //console.log(i + 1);
      this.currentPage=i+1;
      this.$http
        .get("http://www.hzjingbao.cn/api/product", {
          params: {
            lang: this.$i18n.locale,
            type: sessionStorage.getItem('product'),
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.productTitle = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    // 分页的右边按钮
    add(){
      this.currentPage +=1;
      if(this.currentPage>this.page){
        this.currentPage = this.page;
      }
      this.$http
        .get("http://www.hzjingbao.cn/api/product", {
          params: {
            lang: this.$i18n.locale,
            category: sessionStorage.getItem('product'),
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.productTitle = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    //分页的左边按钮
    sub(){
      this.currentPage -=1;
      if(this.currentPage<1){
        this.currentPage = 1;
      }
       this.$http
        .get("http://www.hzjingbao.cn/api/product", {
          params: {
            lang: this.$i18n.locale,
            category: sessionStorage.getItem('product'),
            page: this.currentPage,
            limit: this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.productTitle = res.data.rows;
          this.total = res.data.total;
        })
        .catch(erroe => {
          console.log(error);
        });
    },
    save(productsid){
      sessionStorage.setItem('products', productsid)
    }
  },
  created(){
   // console.log(this.$i18n.locale)
    if(this.$i18n.locale == 'cn'){
      document.querySelector('meta[name="keywords"]').setAttribute('content', '乳胶粉,可再分散乳胶粉,木胶粉,网洞高分子胶粉,脲醛树脂胶粉,木工胶,脲醛树脂,木工胶粉')
      document.querySelector('meta[name="description"]').setAttribute('content', '公司在原木胶粉、可再分散性乳胶粉、木工胶粉、脲醛树脂胶粉等产品基础上，长期与大专院校、科研单位合作，不断研制开发各类高起点、高品质、安全环保的建材类新产品以满足不断发展、不断更新的各类建筑业产品的需要。')
    }else{
      document.querySelector('meta[name="keywords"]').setAttribute('content', 'Latex powder, redisperse latex powder, wood gum powder, net hole polymer rubber powder, urea formaldehyde resin rubber powder, wood gum, urea formaldehyde resin, carpentry rubber powder')
      document.querySelector('meta[name="description"]').setAttribute('content', 'The company has long cooperated with colleges and universities and scientific research institutes on the basis of products such as log gum powder, dispersible latex powder, carpentry gum powder, and urea-formaldehyde resin gum powder. To develop new building materials products with high starting point, high quality, safety and environmental protection to meet the needs of all types of construction products that are continuously developed and updated.')
    }
    
    var id=this.$route.params.productId;
     this.$http
        .get("http://www.hzjingbao.cn/api/product", {
          params: {
            lang: this.$i18n.locale,
            category: id,
            page: this.currentPage,
            limit:this.display
          }
        })
        .then(res => {
          //console.log(res.data);
          this.total= res.data.total;
          this.productTitle = res.data.rows;
          //console.log(this.productTitle);
        })
        .catch(erroe => {
          console.log(error);
        });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/product.vue